export const KEYWORD_UI_UID = {
  profilePic: 'profilePic',
  coverPic: 'coverPic',
  profilePicMeUser: 'profilePicMeUser',
};
